import { useEffect } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { getCurrencyRate, getCurrencyRateFromSource, saveCurrencyRate } from "src/apis/Setting/setting.api";
import toastHelper from "src/components/Forms/Toastify";
import { TBaseRequestResponse } from "src/types/Commons/baseApiRes.model";
import { TCurrencyRate } from "src/types/Systems/settings.model";
import { printMessage } from "src/utils/commons/errors";

export function useCurrencyRate(){
  const{register,control,reset,handleSubmit}=useForm<{currencyRates:TCurrencyRate[]}>(
    
  )
  const {fields}=useFieldArray({control:control,name:"currencyRates"})
    const queryCurrencyRate=useQuery("queryCurrencyRate",()=>getCurrencyRate(),{
      onSuccess:response=>response.succeeded?response.data:null
    })

      const queryCurrencyRateFromSource = useMutation(() => getCurrencyRateFromSource(), {
        onSuccess: async (response: TBaseRequestResponse<TCurrencyRate[]>) => {
          if (response && response.succeeded) {
            reset({currencyRates:response.data})
          }
        },
        onError: (error: any) => {
          printMessage(error.message);
        }
      });
    const saveCurrencyRateMutation = useMutation((rates: {currencyRates:TCurrencyRate[]}) => saveCurrencyRate(rates), {
        onSuccess: async (response: TBaseRequestResponse<boolean>) => {
          if (response && response.succeeded) {
            const data = response.data;
           if(data) toastHelper.showSuccess("Update successfully");
           else  toastHelper.showSuccess("Update failed");
          }
        },
        onError: (error: any) => {
          printMessage(error.message);
        }
      });
      const handleFormSubmit=async(data:{currencyRates:TCurrencyRate[]})=>{
        await saveCurrencyRateMutation.mutate(data)
      }
      useEffect(()=>reset({currencyRates:queryCurrencyRate.data?.data||[]}),[queryCurrencyRate.data?.data])
    return{
      register,
      fields,
      control,
        queryCurrencyRate,
        queryCurrencyRateFromSource,
        saveCurrencyRateMutation,
        handleFormSubmit,
        handleSubmit
    }
}